/**
 * Bottom Navigation Bar — the locked segmented control, docked.
 * 6 tabs: Home · Leagues · Teams · News · Stats · Account. Same flat segmented
 * control as the top navs (line icons, gold active) but the active rail is a 2px
 * bar on TOP of the cell. Routing + active behavior unchanged (activeTab / onTabChange).
 */
import React from 'react';
import { navTheme, navIcons } from '../../services/mobileNavTheme';
import NavCell from './components/NavCell';

const TABS = [
  { id: 'home', iconKey: 'home', label: 'Home' },
  { id: 'leagues', iconKey: 'leagues', label: 'Leagues' },
  { id: 'teams', iconKey: 'teams', label: 'Teams' },
  { id: 'news', iconKey: 'news', label: 'News' },
  { id: 'stats', iconKey: 'stats', label: 'Stats' },
  { id: 'account', iconKey: 'account', label: 'Account' },
];

function BottomNav({ activeTab, onTabChange }) {
  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        ...navTheme.bottomStrip,
        // preserve the 9px bottom inset AND the iPhone safe-area
        paddingBottom: 'calc(9px + env(safe-area-inset-bottom))',
      }}
    >
      <div style={{ display: 'flex', ...navTheme.segment }}>
        {TABS.map((tab, i) => (
          <NavCell
            key={tab.id}
            Icon={navIcons[tab.iconKey]}
            label={tab.label}
            isActive={activeTab === tab.id}
            onClick={() => onTabChange(tab.id)}
            cell={navTheme.bottomCell}
            divider={i > 0}
            style={{ flex: 1 }}
          />
        ))}
      </div>
    </nav>
  );
}

export default BottomNav;
